export default __webpack_public_path__ + "navigation-examples-building-extrusion-thumbnail-480-9778baf3ab0197ee0bc38dc0a37b1939.webp";